import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

export type Calibration = z.output<typeof calibrationSchema>;
export type CalibrationDTO = z.input<typeof calibrationSchema>;

export const calibrationSchema = z.object({
  cameraId: z.string(),
  createdAt: isoDatetimeToDate,
  id: z.string(),
  imageUrl: z.string().nullable(),
  validFrom: isoDatetimeToDate,
  validUntil: isoDatetimeToDate,
});

export const CalibrationUtils = {
  isValidBetween(calibration: Calibration, from: Date, to: Date): boolean {
    return calibration.validFrom <= to && calibration.validUntil >= from;
  },
};
